// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './components/App'
import router from './router'
import Vuetify from 'vuetify'
import api from '@/api'
import CxltToastr from 'cxlt-vue2-toastr'
import * as VueGoogleMaps from 'vue2-google-maps'
import 'vuetify/dist/vuetify.min.css'

var toastrConfigs = {
  position: 'top right',
  showDuration: 1000,
  timeOut: 5000,
  progressBar: true,
  showMethod: 'fadeInUp',
  hideMethod: 'fadeOutDown',
}

Vue.use(CxltToastr, toastrConfigs)

Vue.use(Vuetify)

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyA92fLXWQSL1z3lVh3iz76KRPP6E7TAyBk',
    libraries: 'places', // This is required if you use the Autocomplete plugin 
    // OR: libraries: 'places,drawing' 
    // OR: libraries: 'places,drawing,visualization' 
    // (as you require) 
  }
})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App }
})

Number.prototype.toCurrency = function (withSymbol=false) {
  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0
  });
  return  formatter.format(this)+(withSymbol?" ₽ ":"");
}



// WEBPACK FOOTER //
// ./src/main.js